import { TFormValues } from './interfaces';

export const DEFAULT_VALUES: TFormValues = {
  title: '',
  tariff: null,
  group: null,
  goods: [],
  services: [],
  use_global_discount: false,
};
